import React from 'react';
import styled from 'styled-components';

import Spinner from 'web-app/react/components/loading/spinner/spinner';
import {getProperty} from 'web-app/util/typescript';

export const StyledOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => props.theme.invertedTextSecondary};
    z-index: 2;
    color: ${props => props.theme.invertedText};

    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledLoadingWrapper = styled.div`
    position: relative;
`;

interface LoadingOverlayProps {
    overlayId?: string;
    children: React.ReactNode;
    loading: boolean;
    className?: string;
    ['data-e2e-id']?: string;
    ['data-e2e-overlay-class']?: string;
}

const LoadingOverlay: React.FC<React.PropsWithChildren<LoadingOverlayProps>> = props => {
    const {overlayId, children, loading, className, 'data-e2e-id': dataE2eId} = props;

    return (
        <StyledLoadingWrapper className={className} data-e2e-id={dataE2eId}>
            {loading ? (
                <StyledOverlay id={overlayId} data-e2e-class={getProperty(props, 'data-e2e-overlay-class')}>
                    <Spinner />
                </StyledOverlay>
            ) : null}
            {children}
        </StyledLoadingWrapper>
    );
};

export default LoadingOverlay;
